import {createSlice} from "@reduxjs/toolkit";
import {
  clearIncidentDetail,
  getIncident,
  getIncidentFailure
} from "./incidentDetailSlice";

const initialState = {
  loadingPlaybook: false,
  loadingExecutionForCoa: "",
  playbook: {},
  responseActionsExecuted: {}
};

export const incidentResponseSlice = createSlice({
  name: "incidentResponse",
  initialState,
  reducers: {
    getIncidentPlaybook: (state) => {
      state.loadingPlaybook = true;
    },
    getIncidentPlaybookSuccess: (state, action) => {
      state.loadingPlaybook = false;
      state.playbook = action.payload?.playbook ?? {};
    },
    getIncidentPlaybookFailure: (state) => {
      state.loadingPlaybook = false;
    },
    postIncidentWorkflow: (state, action) => {
      state.loadingExecutionForCoa = action.payload?.coaId;
    },
    postIncidentWorkflowSuccess: (state, action) => {
      state.loadingExecutionForCoa = "";
      state.responseActionsExecuted = action.payload || {};
    },
    postIncidentWorkflowFailure: (state) => {
      state.loadingExecutionForCoa = "";
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(clearIncidentDetail, () => initialState)
      .addCase(getIncident, (state) => {
        state.loadingPlaybook = true;
      })
      .addCase(getIncidentFailure, (state) => {
        state.loadingPlaybook = false;
      })
      .addDefaultCase(() => {});
  }
});

export const {
  getIncidentPlaybook,
  getIncidentPlaybookFailure,
  getIncidentPlaybookSuccess,
  postIncidentWorkflow,
  postIncidentWorkflowFailure,
  postIncidentWorkflowSuccess
} = incidentResponseSlice.actions;

export default incidentResponseSlice.reducer;
